define('app/filters/controls/SelectFilterControl',['require','./InFilterControl','app/visualizations/FormatFactory','glu/util','hbs!./SelectFilterControl.hbs'],function(require) {
	'use strict';

	var InFilterControl = require('./InFilterControl'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		_ = require('glu/util');

	return InFilterControl.extend({
		template: require('hbs!./SelectFilterControl.hbs'),

		initialize: function() {
			this.model.setArity(1);
		},

		onRender: function() {
			this.$('.select-box').comboBox();
		},

		value: function() {
			return this.model.getValue(0);
		},

		label: function() {
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration(),
				displayFormat: this.model.getDisplayFormat()
			});
			return format(this.value());
		},

		selectableOptions: function() {
			var self = this;
			var selectableOptions = this.possibleValues();

			_.each(selectableOptions, function(pv) {
				_.extend(pv, {
					isSelected: self.value() === pv.value.toString()
				});
			});

			return selectableOptions;
		},

		updateModel: function() {
			this.model.setValue(0, this.$el.find('[name=value]').val());
		},

		selectedValues: function() {
			return [this.model.getValue(0)];
		}
	});
});

